module.exports = __webpack_public_path__ + "static/media/logo_text_cn@2x.cd3403f5.png";